import { SET_PRODUCT_CATEGORIES } from '../action-list'

export const setProductCategories = (categories) => ({
  type: SET_PRODUCT_CATEGORIES,
  categories,
})
